import { IconContent } from '../style';

const Done = () => (
  <IconContent fill='currentColor' viewBox='0 0 24 24'>
    <path d='M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' />
  </IconContent>
);

export default Done;
